import { types } from './actions';
import { UNAPPROVED, APPROVED, FINALIZED } from './constants';

const initalState = {
  department: null,
  district: null,
  bonusMonth: null,
  monthBonusState: APPROVED,
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case types.SET_DEPARTMENT: {
      const { department } = action;
      return {
        ...state,
        department,
      };
    }
    case types.SET_DISTRICT: {
      const { district } = action;
      return {
        ...state,
        district,
      };
    }
    case types.SET_BONUS_MONTH: {
      const { bonusMonth } = action;
      return {
        ...state,
        bonusMonth,
      };
    }

    case types.SET_MONTH_BONUS_STATE: {
      const { monthBonusState } = action;
      return {
        ...state,
        monthBonusState,
      };
    }

    default:
      return state;
  }
};

export default reducer;
